import { render, staticRenderFns } from "./AudiologyKpisLayout.vue?vue&type=template&id=ba3e63a6&"
import script from "./AudiologyKpisLayout.vue?vue&type=script&lang=js&"
export * from "./AudiologyKpisLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba3e63a6')) {
      api.createRecord('ba3e63a6', component.options)
    } else {
      api.reload('ba3e63a6', component.options)
    }
    module.hot.accept("./AudiologyKpisLayout.vue?vue&type=template&id=ba3e63a6&", function () {
      api.rerender('ba3e63a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/main-column/AudiologyKpisLayout.vue"
export default component.exports